var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/master-consumable-item-detail.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-fe3d5142!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/master-consumable-item-detail.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/MasterConsumableItemDetail.vue
// module id = 629
// module chunks = 1